export default __webpack_public_path__ + "static/media/AdityaDP.dbe12bd0.jpeg";